import { encodeAbiParameters, encodePacked } from 'viem';
import { installSmartSessionsAbi } from './abi.js';
import { SmartSessionMode } from './types.js';
import { CallType } from '../../module/types.js';
import { GLOBAL_CONSTANTS } from '../../constants.js';
export const getSmartSessionsValidator = ({ sessions, useRegistry = true, hook, }) => {
    return {
        address: GLOBAL_CONSTANTS.SMART_SESSIONS_ADDRESS,
        module: GLOBAL_CONSTANTS.SMART_SESSIONS_ADDRESS,
        initData: sessions?.length
            ? encodePacked(['bytes1', 'bytes'], [
                useRegistry
                    ? SmartSessionMode.ENABLE
                    : SmartSessionMode.UNSAFE_ENABLE,
                encodeAbiParameters(installSmartSessionsAbi, [sessions]),
            ])
            : '0x',
        deInitData: '0x',
        additionalContext: '0x',
        type: 'validator',
        hook,
    };
};
export const getSmartSessionsCompatibilityFallback = () => {
    return {
        address: GLOBAL_CONSTANTS.SMART_SESSIONS_COMPATIBILITY_FALLBACK_ADDRESS,
        module: GLOBAL_CONSTANTS.SMART_SESSIONS_COMPATIBILITY_FALLBACK_ADDRESS,
        initData: '0x',
        deInitData: '0x',
        selector: '0x84b0196e',
        callType: CallType.CALLTYPE_SINGLE,
        additionalContext: '0x',
        type: 'fallback',
    };
};
//# sourceMappingURL=installation.js.map